// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function compareStringArrays(
  compareString: string,
  searchString: string,
) {
  const alphabetOnlyRegex = /[a-zA-Z]+/g;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function createArrayOfWords(str: string) {
    return str.match(alphabetOnlyRegex) || [];
  }

  const objectValues = createArrayOfWords(compareString).map((word) =>
    word.toLowerCase(),
  );
  const searchValues = createArrayOfWords(searchString).map((word) =>
    word.toLowerCase(),
  );
  const closestPartialMatch = searchValues.every((searchWord) =>
    objectValues.some((categoryWord) => categoryWord.includes(searchWord)),
  );

  return closestPartialMatch;
}
